import { render, staticRenderFns } from "./ExpiringBid.vue?vue&type=template&id=7964c782"
import script from "./ExpiringBid.vue?vue&type=script&lang=js"
export * from "./ExpiringBid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports